
import { GenerationTask } from '../types';

export const generateFullHtml = (task: GenerationTask, bodyHtml: string, titleOverride?: string, mediaNameOverride?: string): string => {
  const title = titleOverride || task.articleTitle || task.presetName || 'Generated Document';
  
  return `<!DOCTYPE html>
<html lang="ko">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<meta name="referrer" content="no-referrer">
<title>${title}</title>
<style>
  body { font-family: system-ui, -apple-system, sans-serif; max-width: 800px; margin: 0 auto; padding: 2rem; line-height: 1.6; color: #333; background: #fff; }
  img { max-width: 100%; height: auto; border-radius: 8px; margin: 1rem 0; }
  h1, h2, h3 { color: #111; margin-top: 1.5em; }
  code { background: #f1f5f9; padding: 0.2em 0.4em; border-radius: 0.25em; font-family: monospace; border: 1px solid #e2e8f0; }
  pre { background: #f8fafc; color: #333; padding: 1rem; border-radius: 0.5em; overflow-x: auto; border: 1px solid #e2e8f0; }
  blockquote { border-left: 4px solid #3b82f6; margin: 0; padding-left: 1rem; color: #64748b; background: #eff6ff; padding: 0.5rem; }
  ul { padding-left: 1.5rem; }
</style>
</head>
<body>
${bodyHtml}
</body>
</html>`;
};
